module.exports = __webpack_public_path__ + "static/media/irwin-pt.1f1ed05b.png";